import React, { useContext, useState } from 'react';
import { keyframes } from '@emotion/react';
import tw, { styled } from 'twin.macro';

import useOfflineSubmissionSync from '../../../hooks/offline-submission-sync';
import { FormContext } from '../../shared/contexts/form-context';
import Button from '../../../components/shared/button';
import useOnlineStatus from '../../../hooks/online';

const ManuallyReplayOfflineSubmission = ({ formDesign }) => {
  const { manuallyTriggerReplay, hasQueuedRequests, queuedCount } = useOfflineSubmissionSync();
  const [isReplaying, setIsReplaying] = useState(false);
  const { inForm } = useContext(FormContext);
  const isOnline = useOnlineStatus();

  const handleReplay = () => {
    setIsReplaying(true);
    manuallyTriggerReplay();
  };

  if (!(hasQueuedRequests && inForm && isOnline)) return null;

  return (
    <Container
      style={{
        '--font-family': formDesign?.old.form_font,
      }}>
      <h5>⚠️ ACTION REQUIRED</h5>

      <p>
        You have at least <strong>{queuedCount}</strong> entr{queuedCount === 1 ? 'y' : 'ies'} submitted offline which{' '}
        {queuedCount === 1 ? 'is' : 'are'} yet to be synced.
      </p>

      <Button
        text={isReplaying ? 'Syncing' : 'Sync now'}
        disabled={isReplaying}
        onClick={handleReplay}
        loading={isReplaying}
        variant="filled"
        size="tiny"
        block
      />
    </Container>
  );
};

export default ManuallyReplayOfflineSubmission;

const pulseBorder = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(0, 175, 191, 0.4);
  }
  50% {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  }
`;

const Container = styled.div`
  ${tw`absolute top-3 right-3 ml-3 bg-white rounded-lg p-5 flex flex-col items-center justify-center text-center`};
  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);
  font-family: var(--font-family) !important;
  animation: ${pulseBorder} 1.5s infinite;
  border: 2px solid whitesmoke;
  max-width: 300px;

  > h5,
  p {
    font-family: var(--font-family) !important;
    font-size: 12px;
  }

  button {
    ${tw`border-none outline-none hover:cursor-pointer`};
    font-family: var(--font-family) !important;

    span {
      font-family: var(--font-family) !important;
      font-size: 12px !important;
    }
  }
`;
